// extracted by mini-css-extract-plugin
module.exports = {"container":"LandingV2_container__2U9wd","content":"LandingV2_content__1_gtj"};